/**
 * OioiCartAdded — post add-to-cart confirmation.
 *
 * Desktop: popover anchored under the cart icon; auto-dismisses, click-outside closes.
 * Mobile: bottom slide-up sheet with a backdrop; stays until dismissed.
 *
 * Usage: window.OioiCartAdded.open({ title, variant, price, image, count, cartUrl, checkoutUrl })
 */
(function () {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(min-width: 992px)');
  var AUTO_DISMISS_MS = 6000;
  var SHEET_ANIM_MS = 300;

  var root = document.getElementById('oioiCartAdded');
  var backdrop = document.getElementById('oioiCartAddedBackdrop');
  if (!root) return;

  var els = {
    thumb: document.getElementById('oioiCartAddedThumb'),
    title: document.getElementById('oioiCartAddedTitle'),
    variant: document.getElementById('oioiCartAddedVariant'),
    price: document.getElementById('oioiCartAddedPrice'),
    cart: document.getElementById('oioiCartAddedCart'),
    cartLabel: root.querySelector('[data-cart-added-cart-label]'),
    checkout: document.getElementById('oioiCartAddedCheckout'),
    closeButtons: root.querySelectorAll('[data-cart-added-close]')
  };

  var baseCartLabel = els.cartLabel ? els.cartLabel.textContent : '';
  var autoTimer = null;
  var unmountTimer = null;
  var lastFocus = null;

  function clearAutoTimer() {
    if (autoTimer) {
      clearTimeout(autoTimer);
      autoTimer = null;
    }
  }

  function isOpen() {
    return root.classList.contains('is-visible');
  }

  function open(data) {
    data = data || {};

    if (els.thumb) {
      if (data.image) {
        els.thumb.src = data.image;
        els.thumb.alt = data.title || '';
        els.thumb.style.display = '';
      } else {
        els.thumb.removeAttribute('src');
        els.thumb.style.display = 'none';
      }
    }
    if (els.title) els.title.textContent = data.title || '';
    if (els.variant) {
      els.variant.textContent = data.variant || '';
      els.variant.style.display = data.variant ? '' : 'none';
    }
    if (els.price) els.price.textContent = data.price || '';

    if (els.cartLabel) {
      var count = parseInt(data.count, 10);
      els.cartLabel.textContent = count > 0
        ? baseCartLabel + ' (' + count + ')'
        : baseCartLabel;
    }
    if (els.cart && data.cartUrl) els.cart.href = data.cartUrl;
    if (els.checkout) els.checkout.href = data.checkoutUrl || data.cartUrl || els.checkout.href;

    lastFocus = document.activeElement;

    if (unmountTimer) {
      clearTimeout(unmountTimer);
      unmountTimer = null;
    }

    var mobile = !DESKTOP_MQ.matches;

    if (backdrop && mobile) {
      backdrop.hidden = false;
    }

    // Render first, force a reflow, then flip the class so the sheet slides up.
    root.style.display = 'block';
    void root.offsetWidth;
    root.classList.add('is-visible');
    root.setAttribute('aria-hidden', 'false');
    if (backdrop && mobile) {
      backdrop.classList.add('is-visible');
    } else if (backdrop) {
      backdrop.classList.remove('is-visible');
      backdrop.hidden = true;
    }

    clearAutoTimer();
    if (!mobile) {
      autoTimer = setTimeout(close, AUTO_DISMISS_MS);
    }

    if (els.cart && typeof els.cart.focus === 'function') {
      els.cart.focus();
    }
  }

  function close() {
    if (!isOpen()) return;
    clearAutoTimer();
    root.classList.remove('is-visible');
    root.setAttribute('aria-hidden', 'true');
    if (backdrop) {
      backdrop.classList.remove('is-visible');
    }

    // Let the slide-down / fade finish before removing from the layout.
    unmountTimer = setTimeout(function () {
      root.style.display = 'none';
      if (backdrop) backdrop.hidden = true;
      unmountTimer = null;
    }, SHEET_ANIM_MS);

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
      lastFocus = null;
    }
  }

  /* Dismiss interactions */
  els.closeButtons.forEach(function (btn) {
    btn.addEventListener('click', close);
  });

  if (backdrop) {
    backdrop.addEventListener('click', close);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  /* Click outside closes the desktop popover */
  document.addEventListener('click', function (e) {
    if (!isOpen() || !DESKTOP_MQ.matches) return;
    if (root.contains(e.target)) return;
    // Ignore the add-to-cart button that opened it (its handler runs first).
    if (e.target.closest && e.target.closest('.add-to-cart')) return;
    close();
  });

  /* Pause auto-dismiss while the pointer is over the desktop popover */
  root.addEventListener('mouseenter', function () {
    if (DESKTOP_MQ.matches) clearAutoTimer();
  });
  root.addEventListener('mouseleave', function () {
    if (DESKTOP_MQ.matches && isOpen()) {
      clearAutoTimer();
      autoTimer = setTimeout(close, AUTO_DISMISS_MS);
    }
  });

  window.OioiCartAdded = { open: open, close: close };
})();
